import React, { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";

function TrueFalseQuestion({ statement, correctAnswer, explanation, index }) {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const handleAnswer = (answer) => {
    setSelectedAnswer(answer);
    if (answer === correctAnswer) {
      setFeedback({ type: "success", message: "Correct! " + explanation });
    } else {
      setFeedback({ type: "danger", message: "Wrong! " + explanation });
    }
  };

  return (
    <Card className="true-false-question-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>{index}. True or False?</Card.Title>
        <Card.Text>
          <strong>Statement:</strong> {statement}
        </Card.Text>
        <div>
          <Button
            variant={selectedAnswer === "True" ? "primary" : "outline-dark"}
            onClick={() => handleAnswer("True")}
            // disabled={selectedAnswer !== null}
          >
            True
          </Button>{" "}
          <Button
            variant={selectedAnswer === "False" ? "primary" : "outline-dark"}
            onClick={() => handleAnswer("False")}
            // disabled={selectedAnswer !== null}
          >
            False
          </Button>
        </div>
        {feedback && (
          <Alert variant={feedback.type} className="mt-3">
            {feedback.message}
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
}

export default TrueFalseQuestion;
